<template>
    <div class="popup" style="background: #fff">
     <div>
     
      <el-form class="demo-form-inline" label-width="150px">
  
  
        <el-form-item label="线下学员:">
            <el-select
              placeholder="请选择学生"
              v-model="formDate.student"
              style="width: 100%"
              clearable
              filterable>
              
              <el-option
                v-for="item in studentArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-form-item>
  
        
  
        <el-form-item label="教师姓名:">
          <el-select
            placeholder="请选择师"
            v-model="formDate.teacher"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
  
  
        <el-form-item label="规划学员:">
            <el-select
              placeholder="请选择学生"
              v-model="formDate.student1"
              style="width: 100%"
              clearable
              filterable>
              <el-option
                v-for="item in studentArr1"
                :key="item.id"
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="课时数:">
            <el-input-number style="width: 100%" 
            v-model="formDate.num" placeholder="请选择课时数" 
            controls-position="right" :min="0" :max="10000"></el-input-number>
          </el-form-item> -->
  
  
        <el-form-item label="课程名称:">
          <el-select
            placeholder="请选择课程名称"
            v-model="formDate.curriculum"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in subjectArr"
              :key="item.id"
              :value="item.id"
              :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>
  
        <el-form-item label="上课方式:">
          <el-select
            placeholder="请选择上课方式"
            v-model="formDate.teachingMethods"
            style="width: 100%"
            clearable
            filterable >
            <el-option
              v-for="item in teachingMethodsArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
  
        <el-form-item label="学生类型:">
          <el-select
            placeholder="请选择学生类型"
            v-model="formDate.classType"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in classTypeArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
  
        <el-form-item label="删除方式:">
          <el-select
            placeholder="请选择删除方式"
            v-model="formDate.deleteMethod"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in deleteMethoArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="删除时间">
          <el-date-picker
            v-model="formDate.deleteTime"
            style="width: 100%"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

<!--   
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="formDate.startTime"
            style="width: 100%"
            clearable
            type="date"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
  
        <el-form-item label="结束时间">
          <el-date-picker
            style="width: 100%"
            v-model="formDate.endTime"
            clearable
            type="date"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item> -->


        
        <el-form-item label="日期">
            <el-date-picker
            style="width: 100%"
            v-model="formDate.dateTime"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>


        <el-form-item label="开始时间">
          <el-time-select
            v-model="formDate.startTime"
            :picker-options="{start: '00:00',step: '00:01', end: '24:00'}"
            placeholder="选择开始时间">
          </el-time-select>
        </el-form-item>
  
        <el-form-item label="结束时间">
          <el-time-select
            v-model="formDate.endTime"
            :picker-options="{start: '00:00',step: '00:01', end: '24:00'}"
            placeholder="选择结束时间">
          </el-time-select>
        </el-form-item>


  
      </el-form>
  
      <p style="width: 98%; text-align: right">
        <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search" >搜索</el-button>
        <el-button type="primary"  @click="clearBtn" class="btns" size="small" icon="el-icon-close">清空</el-button >
        <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">一键导出</el-button >
      </p>
  
      <el-table :data="tableData"  height="700" stripe style="width: 99%; margin: 20px auto"  border
        :header-cell-style="{ background: '#fafafa','text-align': 'center', }" :cell-style="{ 'text-align': 'center' }"
        loading-text="数据加载中" v-loading="isLoading" >
  
        <el-table-column prop="teacherName" label="教师姓名" width="200"> </el-table-column>
        <el-table-column prop="studentName" label="学生姓名" width="200"> </el-table-column>
        <el-table-column prop="classType" label="学生类型" width="200"> </el-table-column>
        <el-table-column prop="educationName" label="上课方式" width="200"></el-table-column>
        <el-table-column prop="categoryName" label="课程名称" width="200"></el-table-column>
        <el-table-column prop="courseDate" label="日期" width="200"></el-table-column>
        <el-table-column prop="courseTimeOn" label="开始时间" width="200"></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间" width="200"></el-table-column>
        <el-table-column prop="classNum" label="课时数"> </el-table-column>
        <el-table-column prop="deleteTime" label="删除时间" width="200"></el-table-column>
        <el-table-column prop="delPersonName" label="删除人" width="150"></el-table-column>
        <el-table-column prop="deleteMethod" label="删除方式">
          <template slot-scope="scope">
            <span v-if="scope.row.deleteMethod === 1">单删</span>
            <span v-if="scope.row.deleteMethod === 2">批次号删除</span>
            <span v-if="scope.row.deleteMethod === 3">批量删除</span>
            <span v-if="scope.row.deleteMethod === 4">一键删除</span>
          </template>
        </el-table-column>
        <el-table-column prop="deleteFirstCause" label="一级原因" width="200"></el-table-column>
        <el-table-column prop="deleteTwoCause" label="二级原因" width="200"></el-table-column>
        <el-table-column prop="deleteCause" label="删除原因" width="400"></el-table-column>
      </el-table>
  
      <el-pagination
        style="margin-bottom: 100px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next"
        :total="pagination.total">
      </el-pagination>
  
    </div>
  
    </div>
</template>
  
  <script>
  import { getTeachers, getStudents,  getSubject, getStudentsType } from "@/api/fiveClassApi"
  import {  getList, ApiExhortNews, ApiStatus, ApigetStudentMsgList, ApigetSubjectMsgList, getListApi } from "@/api/weekendReminder"
  import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
  import loadingUtils from "../../utils/loading";
  
  import axios from "axios";
  import apiBaseUrl from "../../../config/api";
  import chatDetailTask from './chatDetailTask'
  import { isReturn } from "../../utils/retnue";
  export default {
    components:{ chatDetailTask },
    data(){
      return{
  
        dataTop: {
          xueguanshenhezhong:0,
          teacherOk:0,
          teacherDaiTiJiao:0,
          marketOk:0,
          marketNotOk:0,
        },
  
        formDate: {
            student:"",
            teacher:"",
            student1:"",
            // num:"",
            curriculum:"",
            teachingMethods:"",
            classType:"",
            deleteMethod:"",
            deleteTime:[],
            startTime:"",
            endTime:"",
            dateTime:[],
        },
  
        ewReminder:{
          teacher:"",
          student:"",
          subject:"",
        },
  
        pagination:{
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
  
        tableData: [],
  
        studentArr:[],
        studentArr1:[],
  
        teacherArr:[],
        subjectArr:[],
        teacherCompletedArr:[{ value: 1, label: "进行中" },{ value: 2, label: "已完成" }],
        salesCompletedArr:[{ value: 2, label: "未完成" },{ value: 1, label: "已完成" }],
        salesReviewArr:[{ value: 3, label: "已审阅" },{ value: 2, label: "未审阅" },{ value: 1, label: "初始待提交" }],
        teachingMethodsArr:[{ value: 1, label: "网课" },{ value: 2, label: "上门" },{ value: 3, label: "门店" }],
        classTypeArr:[{ value: 1, label: "规划" },{ value: 2, label: "线下" },{ value: 3, label: "纯补课" }],
        deleteMethoArr:[{ value: 1, label: "单条删除" },{ value: 2, label: "批次号删除" },{ value: 4, label: "一键删除" }],

        isNewReminder:false,
        screenshotShow:false,
        screenshot:"",
        fileLists:[],
  
  
        isShowImg:false,
        showImg:"",
  
        isLoading:true,
  
        showMsg:null,
  
  
        studentArr_s:[],
        subjectArr_s:[],
  
        showChatDetailTask:false,
        row:null,
  
      }
    },
  
    mounted(){
      this.handleInitialization()
      this.getListData()
      // this.handleApiGetMessageState()
    },
  
    methods:{
    
      downloadBtn(){
        let str = ""
        if(this.formDate.student){
          str = this.formDate.student + ''
          if(this.formDate.student1){
            str =  this.formDate.student + ',' + this.formDate.student1
          }
        }else{
          if(this.formDate.student1){
            str = this.formDate.student1  + ''
          }
        }
        const data = {
            pageNum: this.pagination.pageNo,
            pageSize: this.pagination.pageSize,
            studentIds: str,
            teacherId: this.formDate.teacher,
            categoryId: this.formDate.curriculum,
            educationType: this.formDate.teachingMethods,
            courseStartDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[0] : "",
            courseEndDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[1] : "",
            courseOnStartTime: this.formDate.startTime,
            courseOnEndTime: this.formDate.startTime,
            courseEndStartTime: this.formDate.endTime,
            courseEndEndTime: this.formDate.endTime,
            delStartTime : this.formDate.deleteTime[0],
            delEndTime: this.formDate.deleteTime[1],
            deleteMethod: this.formDate.deleteMethod,
            // classNum: this.formDate.num ? this.formDate.num : '',
        };
        axios.post(`${apiBaseUrl}/schedule/excelDelSchedule`, data, { 
          
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          },
        
            responseType: "blob" }).then((res) => {
            const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "删除历史信息.xlsx"; 
            downloadLink.click();
        });
      },
  
      handleTeacherChange(){
        this.handleApigetStudentMsgList()
      },
      handleStudentChange(){
        this.handleApigetSubjectMsgList()
      },
      handleApigetStudentMsgList(){
        let data = { teacherId: this.ewReminder.teacher }
        ApigetStudentMsgList(data).then((res)=>{
          if(res){
             this.studentArr_s = res
          }
        })
      },
      handleApigetSubjectMsgList(){
        let data = { teacherId: this.ewReminder.teacher, studentId: this.ewReminder.student }
        ApigetSubjectMsgList(data).then((res)=>{
          if(res.data){
             this.subjectArr_s = res.data
          }
        })
      },
      // handleApiGetMessageState(){
      //   ApiGetMessageState().then((res)=>{
      //     if(res.code == 200){
  
      //       let dataTop = {
      //         xueguanshenhezhong: res.data.unfinishedWharn,
      //         teacherOk: res.data.messageTotal,
      //         teacherDaiTiJiao: res.data.accomplisWharn,
      //         marketOk: res.data.marketAccomplish,
      //         marketNotOk: res.data.marketUnfinished,
      //       }
      //       this.dataTop = dataTop
      //     }
      //   })
      // },
      addBtn(){
        this.isNewReminder = true
      },
      searchBtn () {
       this.getListData()
      },
      clearBtn(){
        this.handleAllclear()
        this.getListData()
      },
      dialogCler(){
        this.handleDialogclear()
      },
      dialogSubit(){
        let data = {
          id:"",
          msgType: 2,
          teacherId: this.ewReminder.teacher,
          studentId: this.ewReminder.student,
          subject: this.ewReminder.subject,
        }
        ApiExhortNews(data).then((res)=>{
          if(res.code == 200){
            // this.$message({type: 'success',message: '查询成功'});
            this.isNewReminder = false
            this.getListData()
            this.handleDialogclear()
          }else{
            this.$message({type: 'error',message: '添加失败'});
          }
        })
      },
      handlescreenshotCler(){
        this.screenshot = ""
        this.fileLists = [];
        this.showMsg = null
        this.screenshotShow = false
      },
      handlescreenshotSubmit(){
        let data = {
          msgId: this.showMsg.msgId,
          marketStatus: 1,
          remark: this.screenshot,
        }
        ApiStatus(data).then((res)=>{
          if(res.code == 200){
            this.handlescreenshotCler()
            this.getListData()
          }
        })
      },
      handleDialogclear(){
        this.isNewReminder = false
        this.ewReminder = {
          teacher:"",
          student:"",
          subject:"",
        }
      },
      handleAllclear(){
        this.formDate =  {
            student:"",
            teacher:"",
            student1:"",
            // num:"",
            curriculum:"",
            teachingMethods:"",
            classType:"",
            deleteMethod:"",
            deleteTime:[],
            startTime:"",
            endTime:"",
            dateTime:[],
        }
        this.pagination.pageNo = 1
        this.pagination.pageSize = 10
      },
      getListData(){
        this.isLoading = true
  
        let str = ""
        if(this.formDate.student){
          str = this.formDate.student + ''
          if(this.formDate.student1){
            str =  this.formDate.student + ',' + this.formDate.student1
          }
        }else{
          if(this.formDate.student1){
            str = this.formDate.student1  + ''
          }
        }
  
        let data = {
            pageNum: this.pagination.pageNo,
            pageSize: this.pagination.pageSize,
            studentIds: str,
            teacherId: this.formDate.teacher,
            categoryId: this.formDate.curriculum,
            educationType: this.formDate.teachingMethods,
            courseStartDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[0] : "",
            courseEndDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[1] : "",
            courseOnStartTime: this.formDate.startTime,
            courseOnEndTime: this.formDate.startTime,
            courseEndStartTime: this.formDate.endTime,
            courseEndEndTime: this.formDate.endTime,
            delStartTime : this.formDate.deleteTime[0],
            delEndTime: this.formDate.deleteTime[1],
            deleteMethod: this.formDate.deleteMethod,
            // classNum: this.formDate.num ? this.formDate.num : '',
           classType: this.formDate.classType,
        }
        getListApi(data).then((res)=>{
          isReturn(res.code)
         if(res.code == 200){
            if(res.data){
              this.tableData = res.data.records ? res.data.records : []
              this.isLoading = false
              this.pagination.pageNo = res.data.current
              this.pagination.total = res.data.total
              this.pagination.pageSize = res.data.size
              this.$message({type: 'success',message: '查询成功'});
            }else{
              this.tableData =  []
              this.pagination.pageNo = 1
              this.pagination.total = 0
              this.$message({type: 'success',message: '查询成功'});
              this.isLoading = false
            }
         }else{
            this.$message({type: 'error',message: '查询失败'});
            this.tableData =  []
            this.pagination.pageNo = 1
            this.pagination.total = 0
            this.isLoading = false
         }
        })
        .catch(()=>{
          this.isLoading = false
        })
      },
  
      showChatDetailEvent(even){
        this.showChatDetailTask = even
        this.row = null
      },
  
      detail(row){
        if(row.student && row.teacher){
          // this.$router.push({ path: "/chatDetailTask", query: { row } })
          this.row = row
          this.showChatDetailTask = true
        }else{
          this.$message({type: 'warning',message: '获取老师或学生错误信息'});
        }
      },
      handleSizeChange (v) {
        this.pagination.pageSize = v;
        this.getListData();
      },
  
      handleCurrentChange (v) {
        this.pagination.pageNo = v;
        this.getListData();
      },
  
      handleGetlistData(){
        this.$message({type: 'success',message: '已取消'});
      },
  
      changeMarke (row) {
  
        // if(row.msg.marketStatus == 1){
        //    this.$message({message: '审核状态必须已完成',type: 'warning' });
        // }else{
          this.$confirm('此操作将修改销售完成情况, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               this.screenshotShow = true
               this.showMsg = row.msg
               row.msg.marketStatus = 2
            }).catch(() => {
              row.msg.marketStatus = 2
              this.$message({type: 'warning',message: '已取消'});
            });
        // }
  
      },
  
      handleImgClick(row) {
        this.showImg = row;
        this.isShowImg = true;
      },
  
      handleNewReminderClose(){
        this.isNewReminder = false
        this.handleDialogclear()
      },
  
      handleInitialization(){
        // getStudents().then(res => {
        //   this.studentArr = res.data
        // })
  
        getStudentsType(2).then(res => {
          this.studentArr = res.data
        })
        getStudentsType(1).then(_res => {
          this.studentArr1 = _res.data
        })
  
        getTeachers().then(res => {
          this.teacherArr = res.data
        })
        getSubject().then(res => {
          this.subjectArr = res.data
        })
      },
  
  
      getFileName(name) {
        return name.substring(name.lastIndexOf("."));
      },
      beforeUpload(file) {
        // 限制上传类型
        const fileExtensions =
          this.getFileName(file.name) === ".bmp" ||
          this.getFileName(file.name) === ".tif" ||
          this.getFileName(file.name) === ".gif" ||
          this.getFileName(file.name) === ".pcx" ||
          this.getFileName(file.name) === ".svg" ||
          this.getFileName(file.name) === ".psd" ||
          this.getFileName(file.name) === ".webp" ||
          this.getFileName(file.name) === ".apng" ||
          this.getFileName(file.name) === ".ai" ||
          this.getFileName(file.name) === ".avif" ||
          this.getFileName(file.name) === ".png" ||
          this.getFileName(file.name) === ".pdf"||
          this.getFileName(file.name) === ".jpg";
        //限制的上限为20M
        const max20M = file.size / 1024 / 1024 < 20;
        if (!fileExtensions) {
          this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
        }
        if (!max20M) {
          this.$message.error("上传文件大小不能超过 20MB!");
        }
        return fileExtensions && max20M;
      },
      handleUpload(option) {
        var obj = option.file.name;
        var index = obj.lastIndexOf(".");
        obj = obj.substring(index, obj.length);
        // 生成的文件名，保留文件后缀名，进行拼接
        let objName = getFileNameUUID() + this.getFileName(option.file.name);
        // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
        put(`mz_pc/${objName}`, option.file).then((res) => {
          console.log(res);
          this.screenshot = res.url
          // 上传成功之后，转换真实的地址
          signatureUrl(`mz_pc/${objName}`).then((res) => {
            console.log(res);
          });
        });
      },
      handleRemove(file, fileList) {
        this.fileLists = fileList;
        this.screenshot = ""
      },
  
  
    }
  
  }
  </script>
  
  
  <style scoped>
  header {
    text-align: left;
  }
  
  .pending {
    text-align: left;
  }
  
  .pending p {
    font-size: 14px;
  }
  
  .pending_bottom {
    width: 100%;
    height: 140px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 10px;
  }
  
  .pending_item {
    width: 170px;
    height: 100px;
    border-radius: 10px;
  }
  
  .pending_item p {
    margin-top: 20px;
    margin-left: 25px;
  }
  
  .leave {
    background: linear-gradient(to right, #028bcf, #80d0f6);
  }
  
  .renew {
    background: linear-gradient(to right, #fdbe29, #fecf64);
  }
  
  .communication {
    background: linear-gradient(to right, #5d9656, #aac8a6);
  }
  
  .afterClass {
    background: linear-gradient(to right, #ff698a, #fe9f74);
  }
  
  .first {
    background: linear-gradient(to right, #d87ea3, #e3c5c6);
  }
  
  .classroom {
    background: linear-gradient(to right, #1da8aa, #94e0dd);
  }
  
  .issue {
    background: linear-gradient(to right, #f4ab56, #f6cd9e);
  }
  
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 88%;
    margin: 0 ;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  
  .el-upload {
    border: 1px dashed #d9d9d9 !important;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .demo-form-inline .el-form-item {
    margin-right: 30px;
  }
  
  /* 兼容移动端 */
  @media screen and (max-width: 750px) {
    .fiveLessons {
      width: 1430px;
    }
  
    /* 兼容移动端 */
    #aa>>>.fiveLessons {
      width: 70% !important;
    }
  }
  .el-upload .el-upload--text{
    margin: 0 auto !important;
  }
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/manager/afterSales/asYouPlease.vue